import React from 'react';

class CombineVideoVitalCard extends React.PureComponent {
  render() {
    const {video, videoLink, videoVital, onOpenModal} = this.props;
    return (
      <div className="EmbedBox EmbedBox--standardMargins">
        <div className="GenericByline EmbedBox-stretchedHeader">
          <a className="GenericByline-avatar" href={videoVital._links.combine_team.href}>
            <img src={videoVital._links.combine_team['data-avatar']} />
          </a>
          <div className="GenericByline-details">
            <div>
              {videoVital._links.combine.title}
            </div>
            <div>
              <a href={videoVital._links.combine.href}>
                {videoVital._links.combine_team.title}
              </a>
            </div>
          </div>
        </div>
        {
          videoVital._links.user && videoVital.user_id !== videoVital.creator_id  ? (
            <div className="GenericByline GenericByline--standardMargins">
              <a className="GenericByline-avatar" href={videoVital._links.user.href}>
                <img src={videoVital._links.user['data-avatar']} />
              </a>
              <div className="GenericByline-details">
                <div>
                  <a href={videoVital._links.user.href}>
                    {videoVital._links.user.title}
                  </a>
                </div>
                <div style={{fontWeight: 'bold'}}>
                  {videoLink ? videoLink.description : video.description}
                </div>
              </div>
            </div>
          ): videoVital._links.child ? (
            <div className="GenericByline GenericByline--standardMargins">
              <a className="GenericByline-avatar" href={videoVital._links.child.href}>
                <img src={videoVital._links.child['data-avatar']} />
              </a>
              <div className="GenericByline-details">
                <div>
                  <a href={videoVital._links.child.href}>
                    {videoVital._links.child.title}
                  </a>
                </div>
                <div style={{fontWeight: 'bold'}}>
                  {videoLink ? videoLink.description : video.description}
                </div>
              </div>
            </div>
          ): videoVital._links.team_member ? (
            <div className="GenericByline GenericByline--standardMargins">
              <div className="GenericByline-avatar">
                <img src={videoVital._links.team_member['data-avatar']} />
              </div>
              <div className="GenericByline-details">
                <div>
                  {videoVital._links.team_member.title}
                </div>
                <div style={{fontWeight: 'bold'}}>
                  {videoLink ? videoLink.description : video.description}
                </div>
              </div>
            </div>
          ): (
            <div className="GenericByline GenericByline--standardMargins">
              <div className="GenericByline-avatar">
                <span className="fa fa-clock-o" />
              </div>
              <div className="GenericByline-details">
                <div className="truncatable-line" style={{fontWeight: 'bold', lineHeight: '40px'}}>
                  {videoLink ? videoLink.description : video.description}
                </div>
              </div>
            </div>
          )
        }
        <a className="AspectRatioBox AspectRatioBox--ratio-16-9ish" onClick={onOpenModal}>
          <div className="AspectRatioBoxViewport">
            <img className="AspectRatioBoxViewport-img" src={videoLink ? videoLink.thumbnail : video._links.thumbnail.href} />
            <div className="AspectRatioBoxViewport-overlay2">
              <img className="video-vital-post-overlay" src="/static/img/vitals/video_vitals_logo.png" />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default CombineVideoVitalCard;
